import Axios from 'axios'
import {pageUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_pages (context) {
    Axios.get(pageUrls.getAllPages).then(function (response) {
      context.commit('GET_ALL_PAGES', response.data)
    })
  },
  get_pages (context) {
    Axios.get(pageUrls.getPages).then(function (response) {
      context.commit('GET_PAGES', response.data)
    })
  },
  get_deleted_pages (context) {
    Axios.get(pageUrls.getDeletedPage).then(function (response) {
      context.commit('GET_DELETED_PAGES', response.data)
    })
  },
  get_page (context, publicId) {
    Axios.get(pageUrls.getPage + publicId).then(function (response) {
      context.commit('GET_PAGE', response.data)
    })
  },
  post_page (context, data) {
    Axios.post(pageUrls.postPage, data).then(function () {
      context.dispatch('get_all_pages')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      
    })
  },
  update_page (context, data) {
    Axios.post(pageUrls.editPage, data).then(function () {
      context.dispatch('get_all_pages')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      
    })
  },
  delete_page (context, data) {
    Axios.post(pageUrls.deletePage + data.publicId, data).then(function (response) {
      context.commit('GET_DELETED_PAGES', response.data)
      context.dispatch('get_all_pages')
      // router.push({
      //   name: 'Module.DeletedPages'
      // })
    })
  },
  restorePage (context, publicId) {
    Axios.get(pageUrls.restorePage + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_PAGES', response.data)
      router.push({
        name: 'Module.Pages'
      })
    })
  }
}
